export default __webpack_public_path__ + "static/media/Group2.8d0b0fbc.svg";